import { useSelector } from 'react-redux';
import { RootState } from '../../ducks/store';
import { getLocalTime } from '../../utils';

import './Maintenance.scss';
import { useEffect } from 'react';
import { inMaintenanceMode } from '../../ducks/platformData';
import { useNavigate } from 'react-router-dom';

const renderMaintenanceDateTime = (maintenance?: IMaintenance) => {
  if (!maintenance?.start) return null;

  const localTime = getLocalTime(maintenance.start, maintenance.duration);
  const localDateTime = new Date(maintenance.start).toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="estimate-value">
      <span className="small-value">Today at&nbsp;</span>
      {localTime}
      <span className="normal-value">&nbsp;on {localDateTime}</span>
    </div>
  );
};

export const Maintenance = () => {
  const navigate = useNavigate();

  const { maintenance } = useSelector((state: RootState) => {
    return {
      maintenance: state.platformData.maintenance,
    };
  });

  useEffect(() => {
    if (!inMaintenanceMode(maintenance)) {
      navigate('/login');
    }
  }, [maintenance, navigate]);

  return (
    <>
      <div className="logo-img">
        <img
          src="https://content.praktio.com/asset/praktio-logo-1630678340047.svg"
          alt="Praktio: Make Mistakes"
          className="img-fluid"
        />
      </div>
      <div className="content">
        <div className="gears-img">
          <img
            src="data:image/svg+xml;base64,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"
            alt="Routine System Maintenance"
            className="img-fluid"
          />
        </div>
        <div className="routine-header">Routine System Maintenance</div>
        <div className="update-text">
          Praktio is currently undergoing scheduled updates to ensure you get the best possible
          learning experience. Don't worry—if you were in the middle of a course, we saved your
          progress. We appreciate your patience!
        </div>
        <div className="estimate-text">
          <span className="come-back">Come back after we're up and running. </span>Estimated
          completion:
        </div>
        {renderMaintenanceDateTime(maintenance)}
      </div>
    </>
  );
};

export default Maintenance;
